import _classCallCheck from "/app/node_modules/babel-runtime/helpers/classCallCheck";
export var NotFoundError = function NotFoundError(message, url) {
    _classCallCheck(this, NotFoundError);

    this.message = message;
    this.url = url;
};


//////////////////
// WEBPACK FOOTER
// ./src/abstractions/errors/not-found.js
// module id = ./src/abstractions/errors/not-found.js
// module chunks = 34